/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum FilterKind {
    Default = '0',
    Relative = 1,
    Grouped = 2,
}
